import React from 'react';
import "./styles.scss";
import Button from '@material-ui/core/Button';
import {numberMask} from "../../helper";
import classNames from 'classnames';

interface IErrorBlockProps {
  retry?: () => void,
  title?: string,
  message?: string,
  box?: boolean
}

const ERROR_BLOCK_DEFAULT_TITLE = 'Ошибка';
const ERROR_BLOCK_DEFAULT_MESSAGE = `Проверьте подключение к интернету и попробуйте позднее или обратитесть к администратору. <br /> Дидар: ${numberMask('7777777777', '+7 (###) ### ## ##')}`;

const ErrorBlock: React.FC<IErrorBlockProps> = (props) => {
  const {
    title = props.title ? props.title : ERROR_BLOCK_DEFAULT_TITLE,
    message = props.message ? props.message : ERROR_BLOCK_DEFAULT_MESSAGE,
    box = false,
    retry
  } = props;

  if (props.message) {
    console.log("has", props.message)
  } else {
    console.log("has no", props.message)
  }
  return (
    <div className={classNames("block-error", {
      "block-error--box": box
    })}>
      <p className="block-error__title">
        {title}
      </p>
      <p className="block-error__message"
         dangerouslySetInnerHTML={{__html: message}}/>
      {!!retry && (
        <Button onClick={retry}
                size="small"
                className="block-error__button"
                variant="outlined"
                color="secondary">
          Повторить
        </Button>
      )}
    </div>
  );
};

export default ErrorBlock;
